module.exports = __webpack_public_path__ + "static/media/dark_circle.34733b5f.svg";